import { getAnalytics } from 'firebase/analytics';
import app from './firebase';

let analyticsInstance = null;

export function initAnalytics() {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!analyticsInstance) {
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
}
